import script from "./email-js.vue?vue&type=script&setup=true&lang=js"
export * from "./email-js.vue?vue&type=script&setup=true&lang=js"

import "./email-js.vue?vue&type=style&index=0&id=799be2ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799be2ea"]])

export default __exports__